import ThreeStateToggle, { ToggleState } from "../../common/ThreeStateToggle";
import { PresentationModeToggleTooltipContent } from "./PresentationModeToggle";

type Props = {
    value: ToggleState;
    onChange: (checked: ToggleState) => void;
}

const PresentationModeThreeStateToggle = (props: Props) => {
    return <ThreeStateToggle
        label='Open projects in Presentation Mode by default'
        tooltipContent={<PresentationModeToggleTooltipContent />}
        value={props.value}
        onChange={props.onChange}
    />
}

export default PresentationModeThreeStateToggle;